import { useState } from 'react';
import { ArrowDownIcon } from '~/svgs/common';
import BottomSheet from '~/components/common/bottom-sheet';
type CollapsableSectionProps = {
   title: React.ReactNode;
   children: React.ReactNode;
};
export const DetailsCollapsableSectionMobile = ({ children, title }: CollapsableSectionProps) => {
   const [open, setOpen] = useState(false);

   const onOpen = () => setOpen(true);
   const onClose = () => setOpen(false);

   return (
      <div className="border-t">
         <button
            onClick={onOpen}
            className="flex justify-between w-full py-5 cursor-pointer hover:bg-gray-100/50 focus:outline-none focus:bg-gray-100/50">
            <div className="prose">
               <h3>{title}</h3>
            </div>
            <div>
               <ArrowDownIcon className="transform scale-50 -rotate-90 rtl:rotate-90 mt-1.5" />
            </div>
         </button>
         <BottomSheet
            open={open}
            toggle={onClose}
            header={<div className="text-lg font-bold">{title}</div>}>
            <div className="p-4">{children}</div>
         </BottomSheet>
      </div>
   );
};
